import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminEquipmentService } from '@app/api/api';
import { environment } from 'environments/environment';

export interface UserEquipment {
  id: string | number;
  name?: string;
  brand_name?: string;
  model_name?: string;
  serial_number?: string;
  status?: string;
}

export interface UserOrder {
  id: string | number;
  order_code?: string;
  date?: string;
  total_price?: number;
  status?: string;
}

@Component({
  selector: 'meu-admin-user-equipment',
  templateUrl: './admin-user-equipment.component.html',
  styleUrls: ['./admin-user-equipment.component.scss'],
})
export class AdminUserEquipmentComponent implements OnInit {
  userId: string = '';
  equipmentId: string = '';
  mode: 'list' | 'orders' = 'list';

  lstEquipment: UserEquipment[] = [];
  lstOrders: UserOrder[] = [];
  selectedEquipment: UserEquipment | null = null;
  totalEquipment: number = 0;
  totalOrders: number = 0;
  pageSize = 10;
  pageIndex = 1;
  orderPageSize = 10;
  orderPageIndex = 1;
  host: string = '';
  pageSizeOptions: number[] = [5, 10, 20, 100];

  displayedColumnsEquipment: string[] = ['Index', 'Name', 'Brand', 'Model', 'SerialNumber', 'Status', 'Actions'];
  displayedColumnsOrders: string[] = ['Index', 'OrderCode', 'Date', 'TotalPrice', 'Status'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private adminEquipmentService: AdminEquipmentService
  ) {}

  ngOnInit() {
    this.host = environment.backendhost;
    this.userId = this.route.snapshot.paramMap.get('userId');
    this.equipmentId = this.route.snapshot.paramMap.get('equipmentId');

    if (this.equipmentId) {
      this.mode = 'orders';
      this.loadEquipmentDetail();
      this.loadOrders();
    } else {
      this.mode = 'list';
      this.loadEquipmentList();
    }
  }

  loadEquipmentList() {
    this.adminEquipmentService
      .apiAdminUsersEquipmentGet(this.userId, '', '', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.lstEquipment = res.data.collection || res.data || [];
          this.totalEquipment = res.data.total || this.lstEquipment.length;
          this.ref.detectChanges();
        } else if (Array.isArray(res)) {
          this.lstEquipment = res;
          this.totalEquipment = res.length;
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message || 'Lỗi khi tải danh sách thiết bị');
        }
      });
  }

  loadEquipmentDetail() {
    this.adminEquipmentService
      .apiAdminUsersEquipmentIdGet(this.userId, this.equipmentId)
      .subscribe((res) => {
        if (res.success) {
          this.selectedEquipment = res.data;
        } else if (res && res.id) {
          this.selectedEquipment = res;
        }
        this.ref.detectChanges();
      });
  }

  loadOrders() {
    this.adminEquipmentService
      .apiAdminUsersEquipmentOrdersGet(this.userId, this.equipmentId, this.orderPageIndex, this.orderPageSize)
      .subscribe((res) => {
        if (res.success) {
          this.lstOrders = res.data.collection || res.data || [];
          this.totalOrders = res.data.total || this.lstOrders.length;
        } else if (Array.isArray(res)) {
          this.lstOrders = res;
          this.totalOrders = res.length;
        }
        this.ref.detectChanges();
      });
  }

  viewOrders(equipmentId: string) {
    this.router.navigate(['/admin/user-equipment', this.userId, equipmentId, 'orders']);
  }

  onPageChange(page: number) {
    this.pageIndex = page;
    this.loadEquipmentList();
    window.scrollTo(0, 0);
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageIndex = 1;
    this.loadEquipmentList();
  }

  onOrderPageChange(page: number) {
    this.orderPageIndex = page;
    this.loadOrders();
    window.scrollTo(0, 0);
  }

  goBack() {
    if (this.mode === 'orders') {
      this.router.navigate(['/admin/user-equipment', this.userId]);
    } else {
      this.router.navigate(['/admin/manage-users']);
    }
  }
}
